export default __webpack_public_path__ + "static/media/us-health-vest-atlanta-3.c59b3c43.jpg";